// extracted by mini-css-extract-plugin
export default {"TotalCount":"tableTopPanel_TotalCount__phgsU"};